module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content-wrap"
    }
  }, [(0 > 1) ? _c('input', {
    attrs: {
      "type": "button",
      "value": "testFunction"
    },
    on: {
      "click": function($event) {
        return _vm.testFunction()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box box-widget widget-user-2"
  }, [_c('div', {
    staticClass: "widget-user-header",
    staticStyle: {
      "background-color": "#367fa9",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.goHome()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "height": "80px",
      "cursor": "pointer",
      "padding-left": "1%"
    },
    attrs: {
      "src": require("../../static/img/logo-small.png"),
      "alt": "Printer Counters"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "widget-user-desc",
    staticStyle: {
      "margin-left": "5%",
      "cursor": "pointer"
    }
  }, [_vm._v("Printer Counters Monitoring")]), _vm._v(" "), _c('h5', {
    staticClass: "widget-user-desc",
    staticStyle: {
      "margin-left": "5%",
      "cursor": "pointer"
    }
  }, [_vm._v("Ver. " + _vm._s(_vm.$root.version))])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer no-padding"
  }, [_c('transition', {
    attrs: {
      "name": "page",
      "mode": "out-in"
    }
  }, [(_vm.$route.name === 'Contact') ? _c('Contact') : _vm._e(), _vm._v(" "), (_vm.$route.name === 'Download') ? _c('Download') : _vm._e(), _vm._v(" "), (_vm.$route.name === 'Thanks') ? _c('Thanks') : _vm._e(), _vm._v(" "), (_vm.$route.name === 'Greeting') ? _c('Thanks') : _vm._e(), _vm._v(" "), (_vm.$route.name === 'Verify') ? _c('Verify') : _vm._e(), _vm._v(" "), (_vm.$route.name === 'Login') ? _c('va-login', {
    attrs: {
      "title": "Login to Printer Counters"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$route.name === 'Guide') ? _c('va-login', {
    attrs: {
      "title": "Login to Printer Counters"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$route.name === 'Register') ? _c('va-register', {
    attrs: {
      "title": "Please Register Here To Create New Dealer Account"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('footerBox')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-219136d0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Login.vue
// module id = 679
// module chunks = 0